import { STATUS } from "@/components/pages/landscape/LandscapeManagementInterfaces";

export function isButtonDisabled(status: string): boolean {
    if (!status) return false;
    const lowerStatus = status.toLowerCase();
    return (
        lowerStatus === STATUS.DEPLOYING.toLowerCase() ||
        lowerStatus === STATUS.INCOMPLETE.toLowerCase() ||
        lowerStatus === STATUS.DRAFT.toLowerCase()
    );
}
